<template>
    <div class="step">
        <h1 class="step__question">What's your lifestyle?</h1>

        <ul class="step__answers-wrapper">
            <li v-for="(life_style,i) in options" class="step__answer --life-style" :key="i">
                <div class="answer-wrapper" @click="concern = i" :class="[ answer_css_class(concern === i, life_style) ]">
                    <div class="answer">
                        <Urban v-if="life_style === 'Urban'" />
                        <Suburban v-if="life_style === 'Suburban'" />
                        <Outdoorsy v-if="life_style === 'Outdoorsy'" />
                        <ExtremeClimate v-if="life_style === 'Extreme Climate - High Altitude'" />
                        <FrequentTraveler v-if="life_style === 'Frequent Traveler'" />
                    </div>
                    <p class="answer__text">{{ life_style | modify_text }}</p>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import { bus } from '../../utilities'
import logic from '../../data/logic'
import Urban from '../icons/urban.vue'
import Suburban from '../icons/suburban.vue'
import Outdoorsy from '../icons/outdoorsy.vue'
import ExtremeClimate from '../icons/extreme-climates.vue'
import FrequentTraveler from '../icons/frequent-traveler.vue'

export default {
    name: 'LifeStyles',
    filters: {
        modify_text(text) {
            switch (text) {
                case 'Extreme Climate - High Altitude':
                    return 'Extreme Climate (High Altitude)'
                case 'Outdoorsy':
                    return 'Active'
                default:
                    return text
            }
        }
    },
    components: {
        Urban, Outdoorsy, ExtremeClimate, Suburban, FrequentTraveler
    },
    data() {
        return {
            options: logic.quiz[2].options,
            concern: null
        }
    },
    watch: {
        concern() {
            this.answer(this.concern)
        }
    },
    methods: {
        answer(i) {
            bus.$emit('answer::chosen', i)
        },
        answer_css_class(chosen, life_style) {
            return chosen ? '--chosen' : '--'.concat(this.sluggify(life_style))
        },
        sluggify(str) {
            if (typeof str === 'undefined' || typeof str !== 'string') {
                return str
            }

            return str.toLowerCase()
                .replace(/\s/g, '_')
                .replace(/-/g, '')
        }
    }
}
</script>


// WEBPACK FOOTER //
// source/app/js/components/sections/life-styles.vue